var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var FilterCondition = /** @class */ (function () {
    function FilterCondition(props) {
        this.title = props.title || defaultFilterConditionObject.title;
        // createdFromMonthとcreatedToMonthの両方が指定されているとき、タイムスタンプを比べて、createdFromMonthが先の日時になるように入れ替える
        var shouldSwapDates = props.createdFromMonth != null &&
            props.createdToMonth != null &&
            props.createdFromMonth > props.createdToMonth;
        var createdFromMonth = shouldSwapDates ? props.createdToMonth : props.createdFromMonth;
        var createdToMonth = shouldSwapDates ? props.createdFromMonth : props.createdToMonth;
        this.createdFromMonth = createdFromMonth || defaultFilterConditionObject.createdFromMonth;
        this.createdToMonth = createdToMonth || defaultFilterConditionObject.createdToMonth;
        this.hasAssignment = props.hasAssignment || defaultFilterConditionObject.hasAssignment;
        this.excludesHasAssignment = props.excludesHasAssignment || defaultFilterConditionObject.excludesHasAssignment;
    }
    Object.defineProperty(FilterCondition.prototype, "isEmpty", {
        get: function () {
            if (this.title)
                return false;
            if (this.createdFromMonth != null)
                return false;
            if (this.createdToMonth != null)
                return false;
            if (!this.excludesHasAssignment && this.hasAssignment !== 'ALL')
                return false;
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilterCondition.prototype, "toGqlFilterCondition", {
        get: function () {
            var _a, _b;
            return {
                title: this.title,
                hasAssignment: this.excludesHasAssignment ? false : convertHasAssignmentValueToBoolean(this.hasAssignment),
                createdDatetimeBetween: {
                    fromDatetime: (_a = this.createdFromMonth) === null || _a === void 0 ? void 0 : _a.toString(),
                    toDatetime: (_b = this.createdToMonth) === null || _b === void 0 ? void 0 : _b.endOf('month').toString(),
                },
            };
        },
        enumerable: false,
        configurable: true
    });
    /**
     * フィルター条件をクリアする
     */
    FilterCondition.prototype.clear = function () {
        return new FilterCondition(__assign(__assign({}, defaultFilterConditionObject), { excludesHasAssignment: this.excludesHasAssignment }));
    };
    return FilterCondition;
}());
export { FilterCondition };
export var convertHasAssignmentValueToBoolean = function (value) {
    if (value === 'TRUE')
        return true;
    if (value === 'FALSE')
        return false;
    return undefined;
};
export var defaultFilterConditionObject = {
    title: '',
    createdFromMonth: null,
    createdToMonth: null,
    hasAssignment: 'ALL',
    excludesHasAssignment: false,
};
